// 内部链接，在本页面打开，外部链接，用新的tab页面打开
export const openLinkInSameOrNewTab = (link) => {
  if (link.includes(location.origin)) {
    location.href = link
  } else {
    window.open(link)
  }
};
